import { useParams } from 'react-router-dom';
import { useAppDispatch } from '@shared/hooks';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';
import { useDeleteProgramMutation } from '@src/api/api-hooks/programs/useDeleteProgramMutation.ts';
import { openDialogModal } from 'library/redux/modal';

/**
 * Хук контролирует удаление программы и диалог удаления
 */

export const useProgramDelete = (programId: number) => {
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string; code: string }>();
  // const navigate = useNavigate();
  const { doRedirectOnPrevPage } = usePagesRedirect('programsList');
  // const { program, removeProgram } = useProgram(programId);
  const { mutateAsync: deleteProgramMutation } = useDeleteProgramMutation();
  const isOpen = !!id;
  // const isInManager = url.search('manager') !== -1;

  const remove = async () => {
    // Делаем апи-запрос на удаление и удаляем программу из списка
    // if (!program) return;

    try {
      // removeProgram(program.pk);
      // await xhr.delete(`/api/v1/program/all/${program?.pk}/`);
      await deleteProgramMutation({ id: String(programId) });
      if (isOpen) {
        doRedirectOnPrevPage();
      }
      // if (isOpen) navigate(isOpen ? -1 : url);
    } catch (error) {
      // TODO востановить программу в случае ошибки удаления

      // TODO окно оповещения об ошибке
      console.error(error);
    }
  };
  const removeProgramDialog = async () => {
    dispatch(
      openDialogModal({
        title: 'Удаление программы',
        text: 'Вы действительно хотите удалить видеопрограмму?',
        confirmText: 'Удалить',
        confirm: () => remove(),
        declineText: 'Оставить',
      })
    );
  };
  return {
    removeProgram: removeProgramDialog,
  };
};
